import React from 'react'
import * as UIcons from '@iconscout/react-unicons'
import StatCard from 'components/DetailWidgets/StatCard'
import TabTable from '../TabTable'

const COLUMNS = [
  { key: 'user', label: 'User' },
  { key: 'phone', label: 'Phone' },
  { key: 'joinedOn', label: 'Joined On' },
  { key: 'lastActive', label: 'Last Active' },
  { key: 'pointsEarned', label: 'Points Earned' },
  { key: 'transactions', label: 'Transactions' },
  {
    key: 'status',
    label: 'Status',
    render: (row) => (
      <span className={`px-2 py-0.5 rounded text-xs font-medium ${row.status === 'Active' ? 'bg-success bg-opacity-10 text-success' : 'bg-danger bg-opacity-10 text-danger'}`}>
        {row.status}
      </span>
    )
  }
]

const STATUS_OPTIONS = [
  { label: 'All statuses', value: '' },
  { label: 'Active', value: 'Active' },
  { label: 'Inactive', value: 'Inactive' }
]

export default function ParticipantsTab({ campaign }) {
  const { participants } = campaign

  return (
    <div className="flex flex-col gap-4">
      <div className="grid grid-cols-2 md:grid-cols-5 gap-4">
        {
          participants.stats.map((stat) => (
            <StatCard key={stat.key} icon={UIcons.UilUsersAlt} label={stat.label} value={stat.value} suffix={stat.suffix} trend={stat.trend} tone={stat.tone} />
          ))
        }
      </div>

      <TabTable
        columns={COLUMNS}
        rows={participants.rows}
        searchPlaceholder="Search by user, phone, user ID"
        searchKeys={['user', 'phone']}
        statusOptions={STATUS_OPTIONS}
      />
    </div>
  )
}
